import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { Link } from "react-router-dom";
import Highlighter from "react-highlight-words";

export default function ListDataJobPosition({
  list = [],
  editData,
  deleteData,
  loading,
  titles = [],
  addData,
  listLoading,
}) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) => {
    return checkAccessFn(dashboardData, module, name);
  };

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    CountPerPage,
    Search,
    currentList,
  } = useSearchPagination(list);

  const [searchWords, setSearchWords] = useState([]);

  return (
    <div className="pt-2 uppercase">
      <div className="flex flex-wrap gap-2 mb-1 items-center">
        {checkAccess("Job Position", "job-position-create") && (
          <Link to="/dashboard/actual-profession/create">
            <button
              className="p-2 bg-red  text-white uppercase rounded-md"
              onClick={addData}
            >
              Add New Actual Profession +
            </button>
          </Link>
        )}
        <Search
          searchKey={["name", "short_description"]}
          setSearchWords={setSearchWords}
        />
        <CountPerPage />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1 lg:hidden block">{`Slide / scroll to right >`}</p>
      <div
        className={`grid grid-cols-table-3 gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold uppercase">
            {t}
          </p>
        ))}
        {listLoading && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-full">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        {!listLoading && <NoDataFound />}

        {!listLoading &&
          currentList.map((list, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />

              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.name || ""}
                />
              </p>
              {/* <p>{list.short_description}</p> */}

              <div className="flex gap-3 min-w-fit ">
                {checkAccess("Job Position", "job-position-edit") ? (
                  <button
                    className={
                      listLoading || currentList?.length <= 0
                        ? "p-1 px-2 rounded-md ring-1 ring-slate-600 opacity-50"
                        : "p-1 px-2 rounded-md ring-1 ring-slate-600"
                    }
                    onClick={() => editData(list.id, list)}
                    disabled={
                      loading.edit || listLoading || currentList?.length <= 0
                    }
                  >
                    {loading.edit && loading.loadingId === list.id ? (
                      <CgSpinner className="animate-spin mx-auto" />
                    ) : (
                      <CiEdit size={"1.4rem"} />
                    )}
                  </button>
                ) : (
                  <p className="p-1 px-2 rounded-md ring-1 ring-slate-300">
                    --
                  </p>
                )}
                {checkAccess("Job Position", "job-position-delete") ? (
                  <button
                    className={
                      listLoading || currentList?.length <= 0
                        ? "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red opacity-50"
                        : "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                    }
                    onClick={() =>
                      deleteData((oldState) => ({ open: true, id: list.id }))
                    }
                    disabled={
                      loading.delete || listLoading || currentList?.length <= 0
                    }
                  >
                    {loading.delete && loading.loadingId === list.id ? (
                      <CgSpinner className="animate-spin mx-auto" />
                    ) : (
                      <MdDeleteOutline size={"1.4rem"} />
                    )}
                  </button>
                ) : (
                  <p className="p-1 px-2 rounded-md ring-1 bg-gray-200">--</p>
                )}
              </div>
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-full `}
              />
            </React.Fragment>
          ))}
      </div>
      <Pagination />
    </div>
  );
}
